﻿import { Component } from '@angular/core';
import { Tabla } from '../../tabla';

@Component({ template:  `
    <app-tabla [tabla]="tabla"></app-tabla>
` })
export class GradoUserComponent {

    tabla: Tabla = {
        titulo: 'Curso',
        endPoint:'/rest-api/user/grado',
        editable: true,
        columnas: [
            {
                name: 'ID',
                prop: 'id',
                editable: false,
                resizeable: true,
                sortable: true,
                width: 150
            },
            {
                name: 'Curso',
                prop: 'nombre',
                editable: true,
                resizeable: true,
                sortable: true,
                width: 300
            },
            {
                name: 'Categoria',
                prop: 'categoria',
                cell: 'nombre',
                editable: true,
                resizeable: true,
                sortable: true,
                width: 300
            }
            
        ]
    };

}
